import {
    dom, library
} from '@fortawesome/fontawesome-svg-core';
import {
    faSlidersH,
    faTimes
} from '@fortawesome/free-solid-svg-icons';

export const findIcons = () => {
    if (document.body.classList.contains('woocommerce-page')) {
        library.add(faSlidersH);
        library.add(faTimes);
        dom.watch();
    }
}

export const handleFilterButtonClick = () => {
    const button = document.querySelector('.js-button__filter');
    if (!button) {
        return;
    }
    const filter = document.querySelector('#mk-sidebar')
    if (!filter) {
        return;
    }

    const header = document.querySelector('header.mk-header');

    const closeButton = document.createElement('button');
    closeButton.classList.add('filter--close', 'button');
    closeButton.innerHTML = '<i class="fas fa-times"></i>';
    filter.appendChild(closeButton);

    button.addEventListener('click', () => {
        filter.classList.add('active');
        document.body.style.overflow = 'hidden'; // Block scrolling on body when filter is active.
        filter.style.top = heightInViewPort(header);

        closeButton.addEventListener('click', () => {
            filter.classList.remove('active');
            document.body.style.overflow = ''; // Reset scrolling on body when filter is closed.
        });
    });
}

export const uncheckCategoriesOnCheckedClick = () => {
    const anchors = Array.from(document.querySelectorAll('.widget_product_categories .cat-item a'));
    const categories = Array.from(document.querySelectorAll('.widget_product_categories .cat-item'));
    const store_url = Array.from(document.querySelectorAll('#menu-hoofdmenu .menu-item-link')).find(el => el.innerText.toLowerCase() === 'webshop');

    anchors.forEach(anchor => {
        if (anchor.closest('.current-cat')) {
            anchor.setAttribute('href', store_url.getAttribute('href'));
        }
    });

    categories.forEach(category => {
        category.addEventListener('click', () => {
            category.querySelector('a').click();
        });
    })

}

function heightInViewPort(el) {
    const elementHeight = el.clientHeight;
    const rect = el.getBoundingClientRect();

    console.dir({
        elementHeight,
        rect
    })

    if (rect.top === 0) {
        return `${elementHeight}px`;
    }

    const availableHeight = Math.max(rect.bottom, 0);

    return `${availableHeight}px`;
}
